/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import { createGlobalStyle } from 'styled-components';
import 'primeicons/primeicons.css';
import Card from 'saur_ui_library/src/Molecules/Card/Card';
import MaterialTableComponent from '../../components/module/table/materialTableComponent';
import ExportTable from '../../components/common/component/ExportTable';
import {
  cellReturnDetailIcon,
  collectionPoolColumns,
  columnComponent,
} from '../../utils/helpers/table/tableHelper';
import { useNavigate } from 'react-router-dom';
import { CollectionPoolApi } from '../../utils/api';
import { getParamsEnvironment } from '../../utils/helpers/apiHelper';
import ErrorParameter from '../../components/common/ErrorParameter';
import CriticalitiesInfos from './indicator/CriticalitiesInfos';
import ModalComponent from '../component/ModalComponent';
import Button from 'saur_ui_library/src/Atoms/Input/Button/Button';
import { getYearStartAndEndDatesFormatted } from './collectionPoolHelper';
import rfdc from 'rfdc';
import ResetStyleComponent from '../../components/cssSaur/resetStyleComponent';

const cloneDeep = rfdc();

const CollectionPoolView = () => {
  const contractCode = window.sessionStorage.getItem('contractCode')!;
  const contractLabel = window.sessionStorage.getItem('contractLabel');
  const contractId = window.sessionStorage.getItem('contractId')!;
  const navigate = useNavigate();
  const [columns, setColumns] = useState<any[]>([]);
  const [collectionPools, setCollectionPools] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    // get data for
    const previousYear = new Date().getFullYear() - 1;
    // get collection pools
    getParamsEnvironment(CollectionPoolApi.getCollectionPools(
      contractCode,
      contractId,
      previousYear
    ), setCollectionPools, setLoading, setError);

    // init buttons
    let columns = cloneDeep(collectionPoolColumns);
    // add buttons
    columns[10] = columnComponent(
      '',
      {
        size: 10,
        enableSorting: false,
        id: 'collectionPool-detail',
      },
      cellReturnDetailIcon(navigate, 'collectionPool'),
    );
    setColumns(columns);
  }, []);

  const loaderCollectionPoolTable = () => {
    return (
      <div style={{
        width: '136vh',
        height: '115vh',
        textAlign: 'center',
        display: 'grid',
        borderRadius: '10px',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <span className="loaderCollectionPoolTable"/>
      </div>
    );
  };

  return (
    <Container className='sds-reset-style collectionPool_container'>
      <ResetStyleComponent />
      <Styles />
      {/* titre de l'onglet */}
      <Container className='collectionPool-title'>
        <Word
          variant='p'
          textStyle='title'
          value='BASSIN DE COLLECTE'
          className='page-title'
        />
      </Container>
      {/* Table */}
      {loading === false && collectionPools.length > 0 && 
        <Card automatedTestId={'bassin_de_collecte'}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', justifyContent: 'center', width: '110vh' }}>
              <Word
                variant='span'
                textStyle='normalBold'
                value={"Période de calcul du " + getYearStartAndEndDatesFormatted(new Date().getFullYear() - 1).firstDay + ' au ' + getYearStartAndEndDatesFormatted(new Date().getFullYear() - 1).lastDay}
              />
            </div>
            <div style={{ justifyContent: 'flex-end', display: 'flex', marginBottom: '1vh', width: '30vh' }}>
              <Button
                type='button'
                mode='basic'
                automatedTestId='cp-ecrou-icon'
                onClick={() => setOpenModal(!openModal)}
              >
                <Word
                  className='criticity_infos'
                  value='Comment sont calculées les criticités ?'
                />
              </Button>
            </div>
          </div>
          {openModal && (
            <ModalComponent
              tagName='collectionPool'
              content={
                <Container className='contentContainer'>
                  <Container className='criticalities-title'>
                    <Word
                      className='criticalities-style'
                      variant='span'
                      textStyle='normalBold'
                      value='Comment sont calculées les criticités'
                    />
                  </Container>
                  <Container className='criticalitiesContainer'><CriticalitiesInfos /></Container>
                </Container>
              }
              setOpenModal={setOpenModal}
            />
          )}
          <div style={{ display: 'contents' }}>
            <ExportTable
              data={collectionPools}
              type='CollectionPool'
              contractLabel={contractLabel!}
            />
          </div>
          {/* Table */}
          <MaterialTableComponent
            columns={columns}
            rows={collectionPools}
            rowsPerPage={15}
          />
        </Card>
      }
      {loading === true && loaderCollectionPoolTable()}
      {error && (
        <ErrorParameter
          message="une erreur s'est produite. Veuillez réessayer"
          title=''
          IsVisible={true}
        />
      )}
    </Container>
  );
};

const Styles = createGlobalStyle`

  .sds-reset-style .criticity_infos{
       color: #008BD2;
       font-size: 13px;
       line-height: 18px;
       font-weight: bold;
    }
  .sds-reset-style .loaderCollectionPoolTable {
      width: 48px;
      height: 48px;
      border: 5px solid #FFF;
      border-bottom-color: #243977;
      border-radius: 50%;
      display: inline-block;
      box-sizing: border-box;
      animation: rotation 1s linear infinite;
    }

    @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
  }
  .Mui-TableHeadCell-Content-Labels {
    font-size: 14px;
    font-weight: 600;
    color: rgba(0, 0, 0, 1);
  }
  .MuiTableCell-root MuiTableCell-body MuiTableCell-sizeMedium {
    font-size: 12px;
    font-weight: 400;
    }
  .rain-global-container.sds-reset-style .rainContainer{
    width: 100vh;
  }
  .ecp-global-container.sds-reset-style .ecpContainer .ecpContent{
    width: 80vw;
  }
  .collectionPool_container{
    margin-left: 37vh;
    margin-right: 2%;
    margin-bottom: 2%;
    width:80%;
    .hide-vue-pluie, .hide-vue-ecp, .hide-vue-ili{
      display: none;
    }
    .collectionPool-title{
      margin-top: 35px;
      margin-bottom: 20px;
    }
    table tbody tr{
      height: 40px;
      td{
        align-content: center;
      }
    }
  }

  .sds-container.card{
    border:0px;
  }
`;
export default React.memo(CollectionPoolView);
